import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Landing from "@/pages/Landing";
import CandidateStart from "@/pages/CandidateStart";
import AttemptRunner from "@/pages/AttemptRunner";
import Verify from "@/pages/Verify";
import Admin from "@/pages/Admin";
import { LanguageProvider } from "@/lib/i18n";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/start" element={<CandidateStart />} />
            <Route path="/attempt/:id" element={<AttemptRunner />} />
            <Route path="/verify/:lid" element={<Verify />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="bottom-right" richColors closeButton />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
